// src/components/ProtectedRoute.js
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles }) => {
  const location = useLocation();

  // ✅ 1. Read the session exactly as it's saved in Login.jsx
  const sessionString = localStorage.getItem('userSession');
  
  let isAuthenticated = false;
  let userSession = null;

  if (sessionString) {
    try {
      userSession = JSON.parse(sessionString);
      
      // ✅ 2. Check if sessionId exists and the session hasn't expired
      const hasSessionId = !!userSession.sessionId;
      const isNotExpired = userSession.expiresAt ? Date.now() < userSession.expiresAt : true;
      
      isAuthenticated = hasSessionId && isNotExpired;
    } catch (error) {
      console.error('💥 Failed to parse userSession:', error);
      isAuthenticated = false;
    }
  }

  // ✅ 3. Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Clear corrupted/expired session data just in case
    localStorage.removeItem('userSession');
    
    // Redirect to login, preserving the page they tried to visit
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ✅ 4. Role-Based Access (For Admin/Agent routes)
  // Note: This requires you to add a 'role' to your sessionData (see Step 2 below)
  if (allowedRoles && userSession && !allowedRoles.includes(userSession.role)) {
    // If they are logged in but don't have the right role, kick them out
    return <Navigate to="/unauthorized" replace />; 
  }

  // ✅ 5. If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;